

export const MembershipInfo = () => {
  return <div>
    <h2>Members Info</h2>
    <p>details</p>
  </div>
}